export default __webpack_public_path__ + "media/color/xvc-871b1706.svg";